import React from 'react'

import { Pagination } from 'components'

import { useSearchParams } from 'helpers/hooks'
import type { IParamStaff } from '../model'

interface Props {
  totalPage: number
  loading: boolean
}

export const StaffPagination: React.FC<Props> = ({
  totalPage,
  loading,
}: Props) => {
  const base = 'f-staff-pagination'
  const [searchParams, setSearchParams] = useSearchParams<IParamStaff>({
    _page: 1,
  })

  const handlePageChange = (page: number) => setSearchParams({ _page: page })

  return (
    <div className={base}>
      <Pagination
        currentPage={Number(searchParams._page)}
        totalPages={totalPage}
        disabled={loading}
        onChange={handlePageChange}
      />
    </div>
  )
}

export default StaffPagination
